import { olympusService as e } from "../../services/olympus/olympus.service.js";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { subscribeWithSelector as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
//#region src/lib/stores/entities-store/useEntityAndComponentStore.ts
var i = /* @__PURE__ */ new Set(["name", "locked"]), a = /* @__PURE__ */ new Set([
	"name",
	"visible",
	"showAsHoldoutInAR",
	"visibleInAR",
	"isShadowCaster",
	"materialOverrides"
]), o = /* @__PURE__ */ new Set(["name", "visible"]), s = /* @__PURE__ */ new Set([
	"position",
	"scale",
	"rotation"
]), c = {
	Fog: /* @__PURE__ */ new Set(["fogMode"]),
	Audio: /* @__PURE__ */ new Set(["audioType"]),
	Video: /* @__PURE__ */ new Set(["videoPlayerSourceType"]),
	Collision: /* @__PURE__ */ new Set(["collisionShape"]),
	Light: /* @__PURE__ */ new Set(["lightType"])
};
function l(e, t) {
	return `${e}:${t}`;
}
function u(e) {
	return e.getUniqueId();
}
var d = () => {
	let e = [...C.getState().entities];
	C.getState().setEntities(e);
}, f = (e) => {
	e.forEach((e) => {
		e.events.on("update", ({ dirtyProperties: t }) => {
			if (t.some((e) => a.has(e)) && d(), t.some((t) => {
				let n = t;
				return o.has(t) || c[e.type]?.has(n);
			})) {
				let t = C.getState().components;
				t.findIndex((t) => t.parentId === e.parentId && t.id === e.id) >= 0 ? C.getState().setComponents([...t]) : (console.warn(`Update for component ${e.parentId}:${e.id} not found`), C.getState().setComponents([...t, e]));
			}
		}), e.events.on("messageUpdate", () => {
			d();
		});
	});
}, p = (e) => {
	let t = u(e);
	C.getState().components.find((e) => u(e) === t) ? console.warn(`Attempt to add a known component ${t}`) : (f([e]), C.getState().setComponents([...C.getState().components, e]));
}, m = (e) => {
	let t = C.getState().components.findIndex((t) => u(t) === e);
	if (t >= 0) {
		let e = C.getState().components;
		e.splice(t, 1), C.getState().setComponents([...e]);
	} else console.warn(`Attempt to remove an unknown component ${e}`);
}, h = ({ entity: e, isLocal: t, isGizmo: n }) => {
	Object.keys(e).some((e) => i.has(e)) && !n && d();
}, g = (e, t) => {
	let n = [...C.getState().entities];
	C.getState().setEntities(n);
}, _ = (e) => {
	if (C.getState().entities.some((t) => t.id === e.id)) return;
	let t = [...C.getState().entities, e];
	if (C.getState().setEntities(t), !e.isInternalEntity()) {
		let t = [...C.getState().components, ...e.components];
		f(e.components), C.getState().setComponents(t), e.events.on("update", h), e.events.on("addComponent", ({ component: t, id: n }) => {
			g(e, n), p(t);
		}), e.events.on("deleteComponent", ({ id: t }) => {
			g(e, t), m(l(e.id, t));
		}), e.events.on("updateComponent", ({ id: t }) => g(e, t)), e.events.on("reparented", d);
	}
}, v = (e) => {
	_(e.entity);
}, y = (e) => {
	let t = C.getState().components.filter((t) => t.parentId !== e.entity.id);
	C.getState().setComponents(t), e.entity.components.forEach((t) => m(l(e.entity.id, t.id))), C.getState().setEntities(C.getState().entities.filter((t) => t.id !== e.entity.id)), e.entity.events.off("update", h), e.entity.events.off("reparented", d);
}, b = !1, x = void 0, S = () => {
	e.client.spaceEntities.getAllEntities().forEach(_), C.setState({ spaceEntityLoadComplete: !0 });
}, C = n(r((t, n) => ({
	entities: [],
	components: [],
	nonInternalEntities: [],
	spaceEntityLoadComplete: !1,
	initialise: (e) => {
		e ? b ? console.warn("Multiple initialisations of the space and component store") : (e.internalEvents.on("space-entity-load-complete", S), e.internalEvents.on("v2-entity-added", v), e.internalEvents.on("v2-entity-deleted", y), b = !0, x = e) : console.warn("Initialisations of the space and component store attempted without a valid Olympus client ");
	},
	uninitialise: (e) => {
		b &&= (x !== e && console.warn("Wrong Olympus client passed to uninitialise, correct instance used"), x &&= (x.internalEvents.off("space-entity-load-complete", S), x.internalEvents.off("v2-entity-added", v), x.internalEvents.off("v2-entity-deleted", y), t({
			entities: [],
			nonInternalEntities: [],
			components: [],
			spaceEntityLoadComplete: !1
		}), void 0), !1);
	},
	setEntities: (e) => {
		let n = e.filter((e) => !e.components.some((e) => e.type === "Avatar"));
		t({
			entities: n,
			nonInternalEntities: n.filter((e) => !e.isInternalEntity())
		});
	},
	setComponents: (e) => {
		t({ components: e });
	},
	get: (t) => {
		let r = n().entities.find((e) => e.id === t);
		if (r) return r;
		if (e.client.spaceEntities) try {
			return e.client.spaceEntities.getEntity(t);
		} catch {
			return;
		}
	}
}))), w = (e) => t(C, e);
//#endregion
export { s as ComponentChangesToIgnore, C as entityAndComponentStore, w as useEntityAndComponentStore };
